import { render } from "./rankBadge.vue?vue&type=template&id=2edfbaac&scoped=true"
import script from "./rankBadge.vue?vue&type=script&lang=js"
export * from "./rankBadge.vue?vue&type=script&lang=js"

import "./rankBadge.vue?vue&type=style&index=0&id=2edfbaac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edfbaac"]])

export default __exports__